
const ENDPOINT = process.env.VUE_APP_ENDPOINT;

export interface ApiResult<T> {
  result: IResult;
  data: T;
}

export interface IResult {
  error: boolean;
  title?: string;
  message?: string;
}

/*
class CResult implements IResult {
  public error = false;
  public title = '';
  public message = '';
}
*/

const DIR = 'idh.peacock';

export default class {

  private endpoint = ENDPOINT;
  private headers = new Headers();

  constructor() {
    this.headers.append('Content-type', 'application/json');
    const token = localStorage.getItem(DIR);
    if (token) {
      this.headers.append('authorization', token);
    }
  }

  public getToken() {
    return localStorage.getItem(DIR);
  }

  public setToken(token: string) {
    localStorage.setItem(DIR, token);
  }

  public removeToken() {
    localStorage.removeItem(DIR);
  }

  // Get
  public async get<Out>(adress: string, params?: object | undefined): Promise<ApiResult<Out>> {
    let url = `${this.endpoint}${adress}`;
    if (params) {
      const urlParams = new URLSearchParams();
      for (const key of Object.keys(params)) {
        urlParams.append(key, (params as any)[key]);
      }
      url = `${url}?${urlParams.toString()}`;
    }
    // console.log('adress', adress);
    // console.log('authorization', this.headers.get('authorization'));
    return await this.fetcher<Out>(url, {
      method: 'GET',
      headers: this.headers,
    });
  }

  // Post
  public async post<In, Out>(adress: string, input: In): Promise<ApiResult<Out>> {
    const body = JSON.stringify(input);
    const headersObj = this.headers;
    // console.log('adress', adress);
    // console.log('authorization', this.headers.get('authorization'));
    headersObj.append('Content-Length', body.length.toString());
    return await this.fetcher<Out>(`${this.endpoint}${adress}`, {
      method: 'POST',
      headers: headersObj,
      body,
    });
  }

  // Post
  public async postFile<In, Out>(adress: string, input: In): Promise<ApiResult<Out>> {
    // const body = JSON.stringify(input);
    const body: any = input;
    const headersObj = this.headers;
    // console.log('adress', adress);
    // console.log('authorization', this.headers.get('authorization'));
    headersObj.delete('Content-Type');
    // headersObj.append('Content-Length', body.length);
    return await this.fetcher<Out>(`${this.endpoint}${adress}`, {
      method: 'POST',
      headers: headersObj,
      body,
    });
  }

  // Post
  public async put<In, Out>(adress: string, input: In): Promise<ApiResult<Out>> {
    const body = JSON.stringify(input);
    const headersObj = this.headers;
    headersObj.append('Content-Length', body.length.toString());
    return await this.fetcher<Out>(`${this.endpoint}${adress}`, {
      method: 'PUT',
      headers: headersObj,
      body,
    });
  }

  // Delete
  public async delete<Out>(adress: string, params?: object | undefined): Promise<ApiResult<Out>> {
    let url = `${this.endpoint}${adress}`;
    if (params) {
      const urlParams = new URLSearchParams();
      for (const key of Object.keys(params)) {
        urlParams.append(key, (params as any)[key]);
      }
      url = `${url}?${urlParams}`;
    }
    return await this.fetcher<Out>(url, {
      method: 'DELETE',
      headers: await this.headers,
    });
  }

  private async fetcher<T = any>(input: RequestInfo, init?: RequestInit): Promise<ApiResult<T>> {
    return await wrap(fetch(input, init))
      // 処理毎に分けたかったらあとで分ける
      .then((res: any) => {
        return {result: res.result, data: res.data};
      })
      .catch(async (error: Response) => {
        // console.log('erros', error);
        return {result: {error: true, title: error.statusText, message: error.statusText}, data: null} as any;
      },
    );
  }
}


const wrap = (task: Promise<Response>) => {
  return new Promise((resolve, reject) => {
    task
      .then((response) => {
        if (response.ok) {
          if (response.status === 200) {
            const contentType = response.headers.get('Content-Type');
            // console.log(contentType);
            if (contentType === 'application/zip' || contentType === 'application/octet-stream' || contentType === 'text/csv; charset=utf-8' || contentType === 'application/pdf') {
              response
                .blob()
                .then((res) => {
                  const disposition = response.headers.get('Content-disposition');
                  if (disposition && disposition.indexOf('attachment') >= 0) {
                    const anchor = document.createElement('a');
                    const FILENAME_KEY = 'filename=';
                    const filenameIdx = disposition.indexOf(FILENAME_KEY);
                    if (filenameIdx >= 0) {
                      anchor.download = disposition.slice(filenameIdx + FILENAME_KEY.length, disposition.length).replace(/"/g, '');
                    }
                    anchor.href = window.URL.createObjectURL(res);
                    anchor.click();
                    anchor.remove();
                  }
                  /* 日本語名の場合
                  else {
                    const url = URL.createObjectURL(res);
                    const anchor = document.createElement('a');
                    document.body.appendChild(anchor);
                    console.log(anchor)
                    anchor.download = 'RemoLabo_請求用資料.pdf';
                    anchor.href = url;
                    anchor.click();
                    anchor.remove();
                  }
                  */
                  resolve({ disposition, blob: res } as any);
                })
                .catch((error) => reject(error));
            } else {
              const token = response.headers.get('x-authorization');
              // console.log('disposition', token);
              if (token) {
                localStorage.setItem(DIR, token);
              }
              response
                .json()
                .then((res) => (resolve(res)))
                .catch((error) => reject(error));
            }
          } else {
            reject(response);
          }
        } else {
          reject(response);
        }
      })
      .catch((error) => reject(error));
  });
};

